import React from 'react';
import { Shield } from 'lucide-react';
import SEO from '../components/SEO';
import ServiceCard from '../components/ServiceCard';
import CTASection from '../components/CTASection';
import { servicesData } from '../data/servicesData';

export default function Services({ onOpenConsultation }) {
  return (
    <div className="bg-canvas">
      <SEO
        title="Mental Health & Deaddiction Services | UMED Psychiatric Hospital & Rehabilitation Centre"
        description="Explore UMED's comprehensive psychiatric care, deaddiction treatment, intellectual disability care, counselling, psychotherapy, ECT, and rehabilitation services in Maharashtra."
      />

      {/* Hero */}
      <section className="relative pt-16 pb-20 lg:pt-24 lg:pb-28 bg-[#123B5D] text-white overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#0F766E]/30 via-[#123B5D] to-[#123B5D] pointer-events-none"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full bg-[#0F766E] border border-[#2A9D8F]/30">
              <Shield className="w-3.5 h-3.5 text-[#2A9D8F]" />
              <span className="text-xs uppercase tracking-widest text-white font-semibold">
                CLINICAL SERVICES & CARE PATHWAYS
              </span>
            </div>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white font-normal leading-tight">
              Comprehensive <span className="text-[#2A9D8F]">Mental Health</span> & Deaddiction Care.
            </h1>
            <p className="mt-6 text-base sm:text-lg text-[#D9E8E5] leading-relaxed">
              From psychiatric care and deaddiction treatment to counselling and rehabilitation, UMED offers personalized support for different mental health and recovery needs.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {servicesData.map((service) => (
              <ServiceCard
                key={service.id}
                service={service}
                onOpenConsultation={onOpenConsultation}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Quality Standards Strip */}
      <section className="py-16 bg-[#F5FAF9] border-y border-[#D9E8E5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center sm:text-left">
            <div className="p-6 rounded-2xl bg-white border border-[#D9E8E5] shadow-card">
              <span className="text-xs font-bold uppercase tracking-wider text-[#0F766E] block mb-1">
                24/7 Clinical Oversight
              </span>
              <p className="text-xs text-[#64748B]">
                Continuous on-site medical vigilance by consultant psychiatrists, physicians, and psychiatric nursing teams.
              </p>
            </div>
            <div className="p-6 rounded-2xl bg-white border border-[#D9E8E5] shadow-card">
              <span className="text-xs font-bold uppercase tracking-wider text-[#0F766E] block mb-1">
                Multidisciplinary Care
              </span>
              <p className="text-xs text-[#64748B]">
                Collaborative treatment protocols combining medical management, psychological therapies, and social work.
              </p>
            </div>
            <div className="p-6 rounded-2xl bg-white border border-[#D9E8E5] shadow-card">
              <span className="text-xs font-bold uppercase tracking-wider text-[#0F766E] block mb-1">
                Dignified & Safe Environment
              </span>
              <p className="text-xs text-[#64748B]">
                A respectful, secure, and structured residential setting supporting short-term and long-term recovery.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <CTASection
        onOpenConsultation={onOpenConsultation}
        title="Need Professional Mental Health Support?"
        subtitle="Connect with the UMED team to understand the appropriate care and treatment options for you or your loved one."
        primaryButtonText="Get in Touch"
      />
    </div>
  );
}
